<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hsimposio">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>{{simposio?.titulo}}</h1><br>
                    <p>
                        {{simposio?.intro}}
                    </p>
                    <!---<div id="HsimposioBtn">
                        <button type="button" class="btn" (click)="allSimposios()">TODOS LOS SIMPOSIUM</button>
                    </div>-->
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

    <div class="Fsmps">
        <div class="dOcho dmOnce FsmpInt flx">
            <div class="FsmpTexto"  [innerHTML]="simposio?.contenido"></div>
        </div>

        <!--<div class="FcntHf flx" *ng-if="videook">-->
        <div class="dOcho dmOnce FcntHf flx" *ng-if="videook">
            <div class="dDoce Fvideos">
                <h2 class="dDoce">VÍDEOS</h2>
            </div>
            <div class="dDoce"  [innerHTML]="simposio?.video"></div>
        </div>
    </div>
</div>